import { Component, Input, ViewEncapsulation } from '@angular/core';
import { isNumber } from '@uirouter/core';
import { GraphicCardData } from '../device-model/model/graphic-card-data';

@Component({
    encapsulation: ViewEncapsulation.None, // has styles in common.scss, TODO
    selector: 'dl-gauge',
    templateUrl: './gauge.component.html',
    styleUrls: ['./gauge.component.scss']
})
export class GaugeComponent {
    public static $name: string = 'gauge';
    public MAX_GAUGE = 50;
    @Input() public item: GraphicCardData;

    private DECIMALS = 2;

    public get value(): string {
        return this.item.actualValue ? Number(this.item.actualValue).toFixed(this.DECIMALS) : '0';
    }

    public get gaugeValue(): number {
        if (this.item && isNumber(this.item.minValue) && this.item.maxValue) {
            return (parseInt(this.value, 10) * this.MAX_GAUGE) / (this.item.maxValue - this.item.minValue);
        }
        return 0;
    }
}
